(() => {
  if (window.__soldOutLockInit) return;
  window.__soldOutLockInit = true;

  const SOLD_OUT = 'is-sold-out';
  const FORM = 'form[action*="/cart/add"]';
  const LOCK_TARGETS = `.shopify-payment-button, quantity-input, .quantity, ${FORM} button[name="add"]`;
  const cache = new Map();

  // { [variantId]: available } from Shopify, cached for 30s per product
  const getAvailability = (url) => {
    const hit = cache.get(url);
    if (hit && Date.now() - hit.time < 30000) return hit.promise;
    const promise = fetch(`${url}.js`)
      .then((r) => r.json())
      .then((product) => {
        const map = {};
        product.variants.forEach((v) => (map[v.id] = v.available));
        return map;
      })
      .catch(() => null);
    cache.set(url, { time: Date.now(), promise });
    return promise;
  };

  const sync = async (info) => {
    const token = (info._soldOutToken = (info._soldOutToken || 0) + 1);
    const form = info.querySelector(FORM);
    if (!form) return;

    const atc = form.querySelector('button[name="add"]');
    const idInput = form.querySelector('input[name="id"]');

    // Fallback if availability can't be fetched
    let soldOut = !!atc && (atc.disabled || atc.getAttribute('aria-disabled') === 'true');

    const url = (info.dataset.url || '').split('?')[0];
    if (url && idInput && idInput.value) {
      const map = await getAvailability(url);
      if (token !== info._soldOutToken) return; // superseded by a newer check
      if (map && idInput.value in map) soldOut = !map[idInput.value];
    }

    info.classList.toggle(SOLD_OUT, soldOut);
    info.querySelectorAll(LOCK_TARGETS).forEach((el) => {
      if (el.inert !== soldOut) el.inert = soldOut;
    });
  };

  // Capture phase on document: runs before the theme's own click/submit handlers
  const block = (e) => {
    const info = e.target.closest?.(`product-info.${SOLD_OUT}`);
    if (!info) return;
    const hit =
      e.type === 'submit'
        ? e.target.matches?.(FORM)
        : e.target.closest?.('button[name="add"], .shopify-payment-button');
    if (hit) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  };
  document.addEventListener('click', block, true);
  document.addEventListener('submit', block, true);

  const watched = new WeakSet();
  const watch = (info) => {
    if (watched.has(info)) return;
    watched.add(info);
    sync(info);

    let raf;
    new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => sync(info));
    }).observe(info, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });

    // Variant swatch changes: re-check after the theme updates the form
    info.addEventListener('change', () => {
      setTimeout(() => sync(info), 60);
      setTimeout(() => sync(info), 600);
    });
  };

  // Pick up product-info elements now and any added later (quick view, section reloads)
  document.querySelectorAll('product-info').forEach(watch);
  new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.matches('product-info')) watch(n);
        n.querySelectorAll?.('product-info').forEach(watch);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();